<script lang="ts">
  import { getContext } from 'svelte';
  import type { FollowUpLeadFormComponentProps } from './types';
  import LeadForm from '../LeadFormSection/LeadForm.svelte';
  import LeadFormIntroPartial from '../LeadFormSection/LeadFormIntroPartial.svelte';
  import { DesignSystem as DesignSystemEnum } from '$lib/helpers/design-system';

  export let entryId: FollowUpLeadFormComponentProps['entryId'];
  export let title: FollowUpLeadFormComponentProps['title'];
  export let body: FollowUpLeadFormComponentProps['body'];
  export let introHeadingLevel: FollowUpLeadFormComponentProps['introHeadingLevel'];
  export let introBodyFontSize: FollowUpLeadFormComponentProps['introBodyFontSize'];
  export let introTextAlignment: FollowUpLeadFormComponentProps['introTextAlignment'];

  // Passed down to LeadForm
  export let buttonLabel: FollowUpLeadFormComponentProps['buttonLabel'];
  export let followUpList: FollowUpLeadFormComponentProps['followUpList'];
  export let visibleRows: FollowUpLeadFormComponentProps['visibleRows'];
  export let hiddenFields: FollowUpLeadFormComponentProps['hiddenFields'];
  export let legalField: FollowUpLeadFormComponentProps['legalField'];
  export let richTextAlignment: FollowUpLeadFormComponentProps['richTextAlignment'];
  export let formId: FollowUpLeadFormComponentProps['formId'];
  export let submitUrl: FollowUpLeadFormComponentProps['submitUrl'];
  export let successfulSubmitBannerMessage: FollowUpLeadFormComponentProps['successfulSubmitBannerMessage'];
  export let successfulSubmitBannerDuration: FollowUpLeadFormComponentProps['successfulSubmitBannerDuration'];
  export let disableBanner: FollowUpLeadFormComponentProps['disableBanner'];
  export let locale: FollowUpLeadFormComponentProps['locale'];

  // PWDS specific props
  export let colorMode: FollowUpLeadFormComponentProps['colorMode'];

  // Passed down to phone field
  export let localizedCountryNames: FollowUpLeadFormComponentProps['localizedCountryNames'];

  // Hardcoded translations passed down
  export let successfulSubmitButtonText: FollowUpLeadFormComponentProps['successfulSubmitButtonText'];
  export let failedSubmitBannerMessage: FollowUpLeadFormComponentProps['failedSubmitBannerMessage'];
  export let areMarketStylesEnabled: FollowUpLeadFormComponentProps['areMarketStylesEnabled'];

  const isPWDSEnabled = getContext<DesignSystemEnum>('designSystem') === DesignSystemEnum.PublicWebDesignSystem;

  const showFollowUpForm = () => {};
</script>

{#if visibleRows && visibleRows.length > 0}
  <div class="FollowUpLeadForm__content" class:content-width-large={!isPWDSEnabled} data-entry-id={entryId}>
    {#if title || body}
      <LeadFormIntroPartial {title} {body} {introHeadingLevel} {introBodyFontSize} {introTextAlignment} />
    {/if}

    <LeadForm
      {buttonLabel}
      {followUpList}
      {visibleRows}
      {hiddenFields}
      {legalField}
      {richTextAlignment}
      {formId}
      {submitUrl}
      {localizedCountryNames}
      {successfulSubmitBannerMessage}
      {successfulSubmitBannerDuration}
      {successfulSubmitButtonText}
      {failedSubmitBannerMessage}
      {disableBanner}
      {areMarketStylesEnabled}
      {showFollowUpForm}
      {locale}
      {colorMode}
    />
  </div>
{/if}
